<template>
  <div class="paymentFailed">
    <v-container>
      <v-card class="mx-auto" max-width="800" color="grey darken-2">
        <v-container>
          <h1 class="font-weight-light">{{title}}</h1>
          <br />
          <v-row>
            <v-col align="center" justify="center" pa-5>
              <v-row align-content-center>
                <v-card class="mx-auto" min-width="700">
                  <br />
                  <v-avatar size="200" tile centered>
                    <v-img :src="img"></v-img>
                  </v-avatar>
                  <v-card-text class="title">{{successText}}</v-card-text>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>


<script>
export default {
  data() {
    return {
      title: "Bezahlung Fehlgeschlagen",
      successText: "Etwas hat nicht funktioniert. Ihr Konto wurde nicht belastet. Bitte versuchen Sie es später oder mit einer anderen Bezahlmethode nochmal.",
      img: "/img/cancel.svg"
    };
  }
};
</script>